import styled from "styled-components";

import { Collapse, Tabs, Badge } from "antd";

const { Panel } = Collapse;

export const Container = styled.div`
  width: 100%;
  height: 94vh;
  background: #fcfcfc;
  padding: 25px 25px 50px 35px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
    background-color: #fcfcfc;
  }

  ::-webkit-scrollbar-thumb {
    background: #11a7d9;
    -webkit-border-radius: 1ex;
    -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
  }

  ::-webkit-scrollbar-corner {
    background: #11a7d9;
  }
`;

export const Title = styled.h1`
  color: #11a7d9;
  font-family: "Inter";
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 15px;
`;

export const Hr = styled.hr`
  border-radius: 30px;
  background: #11a7d9;
  width: 376px;
  height: 2px;
  margin-bottom: 24px;
  margin-top: -19.5px;
`;

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 64px;
  gap: 5px;
`;

export const BtnActions = styled.div`
  display: flex;
  height: 35px;
  width: 40px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0px 0.751px 1.503px 0px rgba(16, 24, 40, 0.05);
  background: ${({ $isDelete, $disabled }) => {
    if ($isDelete && !$disabled) {
      return "#024";
    }

    if (!$isDelete && !$disabled) {
      return "#11a7d9";
    }

    if ($disabled) {
      return "#C7C9D9";
    }
  }};
`;

export const CardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 15px;
`;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-tab-btn {
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
    font-size: 24px;
    line-height: 1.5;
    letter-spacing: 0;
    color: rgba(117, 117, 117, 1);
    transition: color 0.3s ease-in-out;
  }
  .ant-tabs-tab-btn:hover {
    color: rgba(17, 167, 217, 1);
  }
  .ant-tabs-ink-bar {
    background-color: rgba(17, 167, 217, 1);
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: rgba(17, 167, 217, 1);
  }
`;

export const DocumentCard = styled.div`
  box-shadow: 2px 2px 2px 0px rgba(155, 155, 155, 0.25);
  border-radius: 8px;
  gap: 16px;
  width: 354px;
  height: 160px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: translateY(-10px) scale(1.06); /* levita mais e aumenta mais */
    box-shadow: 6px 12px 20px rgba(155, 155, 155, 0.45); /* sombra mais intensa */
  }
`;

export const IconBackground = styled.div`
  width: 48px !important;
  height: 52px !important;
  background: rgba(17, 167, 217, 0.06);
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardLabels = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const FlowCardName = styled.p`
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 100%;
  color: rgba(108, 108, 108, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
`;

export const FlowCardStatus = styled.div`
  width: 121px;
  height: 27px;
  margin-bottom: 5px;
  border-radius: 8px;
  font-family: "Open Sans";
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;

  background: ${({ status }) =>
    status === "notSent"
      ? "rgba(239, 209, 38, 0.1)"
      : status === "notStarted"
      ? "rgba(148, 148, 148, 0.1)"
      : "rgba(148, 148, 148, 0.1)"};
  color: ${({ status }) =>
    status === "notSent"
      ? "rgba(239, 209, 38, 1)"
      : status === "notStarted"
      ? "rgba(148, 148, 148, 1)"
      : "rgba(148, 148, 148, 1)"};
`;

export const BadgeCount = styled(Badge)`
  .ant-badge-count {
    width: 24px; /* Updated width */
    height: 24px; /* Updated height */
    border-radius: 56px;
    padding-right: 6px;
    padding-left: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 1);
    background: rgba(239, 209, 38, 1););
  }
`;
